import { gql } from '@apollo/client';

export const GET_CATEGORIES = gql`
  query Categories($includeChildren: Boolean! = true) {
    categories {
      id
      name
      children @include(if: $includeChildren) {
        id
        name
        parentId
      }
      parentId
    }
  }
`;
